import React from 'react'


const CTA = () => {
  return (
    <div className='cta'>
       <a href='https://goo.gl/maps/oWYqpqcwgJnDGu9i6' className='btn' target="_blank"> Tune in </a>
       <a href='#contact' className='btn btn-primary' > Lets Talk</a>
        </div>
  )
}

export default CTA